module.exports = __webpack_public_path__ + "img/sp03.7585ea8d.png";